import { ButtonProps, classNameBtn, iconPosition } from "./types/buttonProps";
import './button.scss'
import { stylizationVerticalAlign } from "../stylization";
import { AdditionalIcon } from "../additionalIcon/additionalIcon";
import { useEffect, useRef } from "react";

const AdditionalPlaceHolder = (placeHolder?: string, style?: React.CSSProperties) => {
    var stylization = style ? style : stylizationVerticalAlign;
    if(placeHolder) return (<span style={stylization}>{placeHolder}</span>);
    return;
}

const Button = (props: ButtonProps) => {
    const refocusRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (props.refocus) {
            setTimeout(() => {
                refocusRef.current?.focus();
            }, 0);
        }
    }, [props.refocus]);
    
    const startIcon = props.iconPosition === iconPosition.Start && props.additionalIcon ? props.additionalIcon : undefined;
    const endIcon = props.iconPosition !== iconPosition.Start && props.additionalIcon ? props.additionalIcon : undefined;
    const secondary = props.BtnProps?.className?.includes(classNameBtn.SmallSecondary) ? true : false;
    const primary = props.BtnProps?.className?.includes(classNameBtn.Small) ? true : false;
    return (
        <button {...props.BtnProps}
            ref={refocusRef} tabIndex={0} onBlur={() => { if (props.setRefocusButton) props.setRefocusButton(false) }}>
        {AdditionalIcon(startIcon, undefined, undefined, secondary)}
        {AdditionalPlaceHolder(props.placeHolder, props.placeHolderStyle)}
        {AdditionalIcon(endIcon, undefined, undefined, secondary, primary)}</button>
    )
}

export default Button;